<template>
   <div id="idFiltrosClientesTerrestresModal">
        <Button
            :size="15"
            color="#FD9137"
            colorText="#ffffff"
            tooltip="Filtrar proveedores"
            icon="fas fa-filter"
            round
            :width="30"
            class="mr-2"
            traslate
            @click.native="actionSetShowModalFiltersClientGroundModal(true)"
        />

        <ui-modal 
            ref="modal" 
            title="Filtro para proveedores terrestres"
            @close="actionSetShowModalFiltersClientGroundModal(false); ActionSetZindexModal(false)"
            size="large"
        >
            <div class="container">
                <div class="row w-100">
                    <div class="col-4">
                        <ui-textbox
                            class="w-100"
                            type="number"
                            label="ID"
                            placeholder="Ingrese ID"
                            v-model.number="id"
                        />
                    </div>

                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Cliente"
                            has-search
                            placeholder       = "Seleccionar"
                            searchPlaceholder = "Buscar"
                            :options          = "clientsList"
                            v-model           = "id_client"
                            :keys             = "selectFormat"
                        /> 
                    </div>
                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Proveedor"
                            has-search
                            placeholder       = "Seleccionar"
                            searchPlaceholder = "Buscar"
                            :options          = "listCarriers"
                            v-model           = "id_provider"
                            :keys             = "selectFormat"
                        /> 
                    </div>
                </div>

                <div class="row w-100 mb-3">
                    <div class="col-6">
                        <date-picker
                            placeholder="Desde"
                            type="date"
                            class="w-100"
                            value-type="format"
                            v-model="from"

                        />
                    </div>
                    <div class="col-6">
                        <date-picker
                            placeholder="Hasta"
                            type="date"
                            class="w-100"
                            value-type="format"
                            v-model="to"

                        />
                    </div>
                </div>

                <div class="row w-100">
                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Retiro/Entrega (Vacío)"
                            has-search
                            placeholder       = "Seleccionar"
                            searchPlaceholder = "Buscar"
                            :options          = "portsList"
                            v-model           = "pol_id"
                            :keys             = "selectFormat"
                        /> 
                    </div>

                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Planta/Bodega"
                            has-search
                            placeholder       = "Seleccionar"
                            searchPlaceholder = "Buscar"
                            :options          = "zonesList"
                            v-model           = "plant_id"
                            :keys             = "selectFormat"
                        /> 
                    </div>

                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Entrega/Retiro (Full)"
                            has-search
                            placeholder       = "Seleccionar"
                            searchPlaceholder = "Buscar"
                            :options          = "portsList"
                            v-model           = "pod_id"
                            :keys             = "selectFormat"
                        />
                    </div>
                </div>

                <div class="row w-100">

                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Tipo de Operación"
                            has-search
                            placeholder       = "Seleccionar"
                            searchPlaceholder = "Buscar"
                            :options          = "integralServiceType"
                            v-model           = "operation_type_id"
                            :keys             = "selectFormat"
                        />
                    </div>

                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Tipo Contenedor"
                            has-search
                            placeholder       = "Seleccionar"
                            searchPlaceholder = "Buscar"
                            :options          = "containerTypes"
                            v-model           = "container_type_id"
                            :keys             = "selectFormat"
                        />
                    </div>

                    <div class="col-4">
                        <ui-select
                            class="w-100"
                            label="Moneda"
                            has-search
                            placeholder       = "Seleccionar"
                            searchPlaceholder = "Buscar"
                            :options          = "listCurrencies"
                            v-model           = "currency_id"
                            :keys             = "selectFormat"
                        />
                    </div>
                </div>

                <div class="row w-100">
                    <div class="col mt-4">
                        <Button
                            v-if="showBtnExportFiltersClientGroundModal"
                            text="Exportar"
                            :width="110"
                            :height="37"
                            class="float-right ml-3"
                            color="#21831b"
                            colorText="#fff"
                            icon="far fa-paper-plane"
                            title="Exportar a Excel"
                            horizontal
                            :inactive="btnAction"
                            @click.native="generateReport"

                        />
                        <Button
                            v-else
                            text="Filtrar"
                            :width="110"
                            :height="37"
                            class="float-right ml-3"
                            color="#21831b"
                            colorText="#fff"
                            icon="far fa-paper-plane"
                            title="Filtrar"
                            horizontal
                            :inactive="btnAction"
                            @click.native="filter"
                        />

                        <Button
                            text="Limpiar"
                            :width="110"
                            :height="37"
                            class="float-right"
                            color="#21831b"
                            colorText="#fff"
                            icon="far fa-trash-alt"
                            title="Limpiar"
                            horizontal
                            :inactive="btnAction"
                            @click.native="clear"
                        />

                        <Button
                            text="Cerrar"
                            :width="110"
                            :height="37"
                            class="float-left"
                            color="#21831b"
                            colorText="#fff"
                            icon="fa fa-times"
                            title="Cerrar"
                            horizontal
                            @click.native="actionSetShowModalFiltersClientGroundModal(false)"
                            :inactive="btnAction"
                        />
                    </div>
                </div>
            </div>
        </ui-modal>

   </div>

</template>

<script>

    // UI Modal
    import UiModal from "keen-ui/src/UiModal";
    import Button from '@/components/common/Button.vue';
    import { mapActions, mapState } from "vuex";
    import DatePicker from "vue2-datepicker";
    import { tariffClientsGroundExport, tariffClientsGroundFilter } from "../../../../constants/serviciosLogisticos";
    import { downloadFile } from "../../../../mixins";

    export default {

        data(){
            return {
                selectFormat : { value: 'id', label: 'name' },

                id : "",
                id_client: {} ,
                id_provider : {},
                from: "" ,
                to: "" ,
                id_retiro: {},
                pol_id : {},
                plant_id : {},
                pod_id : {},
                ground_provider_id : {},
                container_type_id : {},
                operation_type_id : {},
                currency_id : {},

                btnAction : false,
            }
        },
        components: {
            UiModal,
            Button,
            DatePicker
        },
        computed: {
            ...mapState("serviciosLogisticos", [
                "showModalFiltersClientGroundModal",
                "showBtnExportFiltersClientGroundModal",
                "clientsList",
                "listCarriers",
                "portsList",
                "integralServiceType",
                "containerTypes",
                "listCurrencies",
                "zonesList"
            ]),
        },
        methods : {

            ...mapActions(["ActionSetZindexModal"]),

            ...mapActions("serviciosLogisticos", [
                "actionSetShowModalFiltersClientGroundModal",
                "actionSetDataTableClientGround",
                "actionSetShowBtnExportFiltersClientGroundModal"
            ]),

            openModal(ref) {

                this.ActionSetZindexModal(true)
                this.$refs[ref].open();
            },
            
            closeModal(ref) {
                this.$refs[ref].close();
            },
            cerrarModal(){
                this.closeModal('modal');
            },
            clear(){
                this.id = "";
                this.id_client= {} ;
                this.id_provider = {};
                this.from= "" ;
                this.to= "" ;
                this.id_retiro= {};
                this.pol_id = {};
                this.plant_id = {};
                this.pod_id = {};
                this.ground_provider_id = {};
                this.container_type_id = {};
                this.operation_type_id = {};
                this.currency_id = {};
            },
            generatePayload(){

                return {
                    id          : this.id == "" ? null : this.id ,
                    id_client   : this.id_client.id ?? null ,
                    id_provider : this.id_provider.id ?? null ,
                    from        : this.from == "" ? null : this.from ,
                    to          : this.to == "" ? null : this.to ,
                    pol_id      : this.pol_id.id ?? null ,
                    plant_id    : this.plant_id.id ?? null ,
                    pod_id      : this.pod_id.id ?? null ,
                    operation_type_id      : this.operation_type_id.id ?? null ,
                    container_type_id      : this.container_type_id.id ?? null ,
                    currency_id            : this.currency_id.id ?? null ,
                }
            },
            async filter(){

                const payload = this.generatePayload() ;
                
                try {
                    this.$vToastify.loader("Filtrando...");

                    const { data } = await tariffClientsGroundFilter( payload ) ;

                    this.actionSetDataTableClientGround( data );

                    this.$vToastify.stopLoader() ;

                    return this.actionSetShowModalFiltersClientGroundModal(false) ;

                } catch (error) {

                    this.$vToastify.stopLoader();
                    return this.$vToastify.error("Hubo un problema al intentar filtrar datos. Favor, recargue la página y vuelva a intentar.", "Error");
                };
            },
            async generateReport(){

                const payload = this.generatePayload() ;

                try {
                    this.$vToastify.loader("Exportando...");

                    const { data } = await tariffClientsGroundExport( payload ) ;

                    this.$vToastify.stopLoader() ;

                    downloadFile( data , 'tariff_client_ground.xlsx' ) ;

                } catch (error) {

                    this.$vToastify.stopLoader();

                    return this.$vToastify.error("Hubo un problema al generar reporte. Favor, recargue la página y vuelva a intentar.", "Error");
                };
            }

        },
        watch: {
            showModalFiltersClientGroundModal: function( _new ){

                !_new && this.actionSetShowBtnExportFiltersClientGroundModal(false) ;
                
                _new ? this.openModal("modal") : this.cerrarModal() ;
            }
        }

    }

</script>

<style>

#idFiltrosClientesTerrestresModal .mx-input {
    padding-left: 2px !important;
    border-radius: 0 !important;
    border: none !important;
    border-bottom: 1px solid #dcdcdc !important;
    box-shadow: none !important;
    margin-top: 18px;
}
</style>